<h3 i18n="Title for the story removal confirmation dialog@@REMOVE_IMAGE">Are you sure you wish to remove this photo?</h3>

<button class="submit" (click)="dialogRef.close(true)" i18n="Text for the button to confirm the image deletion in the story image removal confirmation dialog@@DELETE_PHOTO">Delete the photo</button>
<button class="text-btn" (click)="dialogRef.close()" i18n="Text for the button to cancel the action in progress@@CANCEL">Cancel</button>
